module.exports = __webpack_public_path__ + "img/error.88fee0e4.svg";